export const CATEGORIES = ['essential', 'analytics', 'marketing'] as const;
export type Category = typeof CATEGORIES[number];
export function isValidCategory(c: string): c is Category {
  return (CATEGORIES as readonly string[]).includes(c);
}
